import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Grid2,
  Divider,
} from "@mui/material";
import { Iconify } from "../Minimal/src/components/iconify";
import { API_URL } from "../Config";
import config from "../common/Config";
import PrintPurchaseOrderInvoice from "./PrintPurchaseOrderInvoice";
import "../common/commonStyles.css";

const PurchaseOrderInvoice = (props) => {
  const { orderId } = useParams();
  const [shopDetails, setShopDetails] = useState([]);
  const [commonData, setCommonData] = useState([]);
  const [productData, setProductDetails] = useState([]);
  const [totalVat, setTotalVat] = useState(0);
  const [totalVal, setTotalVal] = useState(0);
  const [totalzeroGoods, setTotalzeroGoods] = useState(0);
  const [totalstd, setTotalstd] = useState(0);

  const accessToken = localStorage.getItem("accessToken");
  const company_tax_type = localStorage.getItem("company_tax_type");
  const currencySymbol = localStorage.getItem("currencySymbol");
 
  const fetchInvoice = async () => {
    const formData = new FormData();
    formData.append("id", orderId);
    const apiUrl = `${API_URL}/purchases/getpurches_items`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch Not Order Report");
      }
      const data = await response.json();
      console.log(data.purchase);
      setShopDetails(data.shop_details);
      setCommonData(data.commonData[0]);
      setProductDetails(data.purchase);

      const grandTotal = data.purchase.reduce((acc, item) => {
        const pdtVat = (parseFloat(item.unit_cost) * parseFloat(item.quantity)) * parseFloat(item.rate) / 100;
        const stotal = parseFloat(item.unit_cost) * parseFloat(item.quantity);
        const pdtTotal = pdtVat + stotal;
        return acc + pdtTotal;
      }, 0);

      // Update state with grand total
      setTotalVal(formatNumber(grandTotal));



      const TotalVatCalculate = data.purchase.reduce((acc, item) => {
        const vat = item.tax;
        return acc + parseFloat(vat);
      }, 0);

      setTotalVat(formatNumber(TotalVatCalculate));

      const totalstd = data.purchase
        .filter(item => parseFloat(item.rate) !== 0 && item.rate != '0.0000')
        .reduce((sum, item) => sum + (parseFloat(item.unit_cost) * parseFloat(item.quantity)), 0);

      const totalzeroGoods = data.purchase
        .filter(item => parseFloat(item.rate) === 0 || item.rate == '0.0000')
        .reduce((sum, item) => sum + (parseFloat(item.unit_cost) * parseFloat(item.quantity)), 0);

      setTotalstd(formatNumber(totalstd));
      setTotalzeroGoods(formatNumber(totalzeroGoods));

    } catch (error) {
      console.error("api fail Error fetching Not Order Report:", error);
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchInvoice();
  }, []);

  const formatNumber = (num) => {
    return parseFloat(num).toFixed(2);
  };

  const isMeatsCategory = (row) => {
    if (!row) return false;
    const cat = (row.category || row.categorie_name || "").toString().trim();
    return cat === "MEATS" || cat === "Meats" || cat === "meats";
  };
  const formatQuantityDecimal = (val) => {
    if (val === undefined || val === null || val === '') return '0';
    const n = parseFloat(val);
    if (Number.isNaN(n)) return String(val);
    return Number.isInteger(n) ? String(n) : String(Number(n.toFixed(4)));
  };
  const formatQuantityForDisplay = (row, quantity) => {
    return isMeatsCategory(row) ? formatQuantityDecimal(quantity) : String(parseInt(quantity, 10) || 0);
  };

  const handleGenerateDeliveryNotePDF = (e, orderId) => {
    PrintPurchaseOrderInvoice(orderId);
  };

  const calculateRowVat = (row) => {
    return (row.unit_cost * row.quantity * row.rate) / 100;
  };

  const calculateRowTotal = (row) => {
    const pdtVat = calculateRowVat(row);
    const stotal = row.unit_cost * row.quantity;
    return pdtVat + stotal;
  };

  return (
    <Box>
      <Box sx={{ width: "100%", p:1.5, backgroundColor: "#f5f7fa" }}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2,
            border: "1px solid rgba(145, 158, 171, 0.16)",
            overflow: "hidden",
            backgroundColor: "#fff",
          }}
        >
          <Box sx={{ p:2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography variant="h5" sx={{ fontWeight: 600, color: "#212b36" }}>
                Purchase Order Invoice
              </Typography>
              <Button
                variant="contained"
                className="button-variant-contained"
                startIcon={<Iconify icon="eva:printer-fill" width={16} />}
                onClick={(e) => handleGenerateDeliveryNotePDF(e, orderId)}
              >
                Print Invoice
              </Button>
            </Box>

            <Grid2 container spacing={3} sx={{ mb: 3 }}>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <Typography  sx={{ fontWeight: 600, fontSize: "0.875rem", color: "#212b36"}}>
                  {commonData.name}
                </Typography>
                <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.8rem"}}>
                  {commonData.note}
                </Typography>
                <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.8rem"}}>
                  Tel: {commonData.phone}
                </Typography>
                <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.8rem"}}>
                  Email: {commonData.email}
                </Typography>
                <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.8rem" }}>
                  GST No: {commonData.gst_no}
                </Typography>
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <Typography  sx={{ fontWeight: 600,fontSize: "0.875rem", color: "#212b36"}}>
                  {shopDetails.shop_name}
                </Typography>
                <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.8rem" }}>
                  {shopDetails.address}
                </Typography>
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <Typography  sx={{ fontWeight: 600,fontSize: "0.875rem", color: "#212b36"}}>
                  Reference: {shopDetails.shop_name}
                </Typography>
                <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.8rem"}}>
                  Date: {commonData.date ? new Date(commonData.date).toLocaleDateString("en-GB") : ""}
                </Typography>
                <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.8rem" }}>
                  Status: {commonData.status}
                </Typography>
              </Grid2>
            </Grid2>

            <TableContainer
            >
              <Table
                size="medium"
                className="table-cell-border"
                sx={{ tableLayout: "fixed" }}
              >
                <TableHead>
                  <TableRow 
                  className="table-cell-header"
                  >
                    <TableCell >
                      Description
                    </TableCell>
                    <TableCell align="center" sx={{ width: 100 }}>
                      Quantity
                    </TableCell>
                    <TableCell align="center" sx={{ width: 80 }}>
                      Type
                    </TableCell>
                    <TableCell align="center" sx={{ width: 120 }}>
                      Unit Cost
                    </TableCell>
                    <TableCell align="center" sx={{ width: 120 }}>
                      {company_tax_type}
                    </TableCell>
                    <TableCell align="center" sx={{ width: 120 }}>
                      Subtotal
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productData.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                        <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.75rem" }}>
                          No products available
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    productData.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(145, 158, 171, 0.04)",
                          },
                          "& .MuiTableCell-root": {
                            fontSize: "0.75rem",
                            color: "#212b36",
                            py: 1.5,
                          },
                        }}
                      >
                        <TableCell>
                          {row.product_code} - {row.product_name}
                        </TableCell>
                        <TableCell align="center">{formatQuantityForDisplay(row, row.quantity)}</TableCell>
                        <TableCell align="center">{row.type === "1" ? "Box" : "Piece"}</TableCell>
                        <TableCell align="center">
                          {currencySymbol} {formatNumber(row.unit_cost || 0)}
                        </TableCell>
                        <TableCell align="center">
                          {currencySymbol} {formatNumber(calculateRowVat(row))}
                        </TableCell>
                        <TableCell align="center">
                          {currencySymbol} {formatNumber(calculateRowTotal(row))}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
                <TableFooter sx={{ 
                  "& .MuiTableCell-root": {
                    borderBottom: "none",
                  }
                }}>
                  <TableRow sx={{
                    "& .MuiTableCell-root": {
                      fontSize: "0.75rem",
                      fontWeight: 500,
                      color: "#212b36",
                      py: 0.5,
                      borderBottom: "none",
                    }
                   }}>  
                    <TableCell colSpan={5} align="right" >
                      Non VAT Goods
                    </TableCell>
                    <TableCell align="center" >
                    {currencySymbol} {totalzeroGoods} 
                    </TableCell>
                    </TableRow>
                    <TableRow sx={{ 
                      "& .MuiTableCell-root": {
                        fontSize: "0.75rem",
                        fontWeight: 500,
                        color: "#212b36",
                        py: 0.5,
                        borderBottom: "none",
                      }
                     }}>
                    <TableCell colSpan={5} align="right" >
                      VAT Goods
                    </TableCell>
                    <TableCell align="center" >
                      {currencySymbol} {totalstd}
                      </TableCell>
                  </TableRow>
                  <TableRow sx={{
                    '& .MuiTableCell-root': {
                      fontSize: "0.75rem",
                      fontWeight: 500,
                      color: "#212b36",
                      py: 0.5,
                      borderBottom: "none",
                    }
                   }}>
                    <TableCell colSpan={5} align="right" >
                      {company_tax_type} Amount
                    </TableCell>
                    <TableCell align="center" >
                      {currencySymbol}  {totalVat}
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{
                    "& .MuiTableCell-root": {
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      color: "#212b36",
                      py: 0.5,
                      borderBottom: "none",
                    }
                   }}>
                    <TableCell colSpan={5} align="right" >
                      Total Amount
                    </TableCell>
                    <TableCell align="center" >
                      {currencySymbol} {totalVal}
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>

            <Box sx={{ mt: 3, textAlign: "center" }}>
              <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.75rem", fontStyle: "italic" }}>
                No claims for damages or short delivery will be considered unless made at the time of delivery of goods.
                These goods are not sold on a sale or return basis.
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default PurchaseOrderInvoice;
